import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "master"]

  connect() {
    this.refreshMaster()
  }

  checkboxTargetConnected() {
    this.refreshMaster()
  }

  masterTargetConnected() {
    this.refreshMaster()
  }

  toggleAll(event) {
    this.setCheckboxes(event.target.checked)
  }

  selectAll(event) {
    if (event) event.preventDefault()
    this.setCheckboxes(true)
  }

  deselectAll(event) {
    if (event) event.preventDefault()
    this.setCheckboxes(false)
  }

  setCheckboxes(checked) {
    this.checkboxes().forEach((checkbox) => {
      if (!checkbox.disabled) {
        checkbox.checked = checked
      }
    })
    this.refreshMaster()
  }

  checkboxes() {
    const targetedCheckboxes = this.hasCheckboxTarget ? this.checkboxTargets : []
    const namedCheckboxes = this.element.querySelectorAll("input[type='checkbox'][name='supplier_order_item_ids[]']")

    return Array.from(new Set([
      ...targetedCheckboxes,
      ...namedCheckboxes
    ]))
  }

  enabledCheckboxes() {
    return this.checkboxes().filter((checkbox) => !checkbox.disabled)
  }

  refreshMaster() {
    if (!this.hasMasterTarget) return

    const checkboxes = this.enabledCheckboxes()
    const checkedCount = checkboxes.filter((checkbox) => checkbox.checked).length

    this.masterTarget.disabled = checkboxes.length === 0
    this.masterTarget.checked = checkboxes.length > 0 && checkedCount === checkboxes.length
    this.masterTarget.indeterminate = checkedCount > 0 && checkedCount < checkboxes.length
  }
}
